import * as React from "react";

import { PrefetchedContent } from "../components/prefetch";
import { UnauthAppContent } from "../components/AppContent";
import { CrisisBanner } from "../components/Banner";
import { PageManifestCrisisBanner } from "../components/Banner/CrisisBanner";
import Breadcrumbs, { getBreadcrumbsContent } from "../components/Breadcrumbs";
import RootWrapper from "../components/RootWrapper";
import { SuppressAndroidInstallPrompt } from "../components/SuppressAndroidInstallPrompt";
import { SkipLink } from "../components/SkipLink";

//TODO: Type this exactly to match what tal-core passes on.
export interface AppProps {
  children?: React.ReactNode;
  showNativeAppAd?: boolean;
  setupFonts?: boolean;
  showHeader?: boolean | "unauth" | "scoped";
  prefetchContent?: Record<string, PrefetchedContent>;
  crisisBanner?: PageManifestCrisisBanner;
  storyMode?: boolean;
}

export const CMSHeader = ({
  showNativeAppAd = true,
  showHeader = true,
  setupFonts = false,
  prefetchContent = {},
  crisisBanner = "top",
  storyMode = false,
}: AppProps) => {
  const breadcrumbsContent = getBreadcrumbsContent(prefetchContent);

  const HeaderContent = (
    <div>
      {crisisBanner === "top" && <CrisisBanner position={crisisBanner} />}
      {!showNativeAppAd && <SuppressAndroidInstallPrompt />}
      <SkipLink target="#page" />
      <UnauthAppContent
        showHeader={showHeader}
        title=""
        actionBar={{ hidden: true }}
        crisisBanner={crisisBanner}
      />
      {crisisBanner === "float" && <CrisisBanner position={crisisBanner} />}
      {breadcrumbsContent && <Breadcrumbs data={breadcrumbsContent} />}
    </div>
  );

  return storyMode ? (
    HeaderContent
  ) : (
    <RootWrapper setupFonts={setupFonts}>{HeaderContent}</RootWrapper>
  );
};
